module.exports = __webpack_public_path__ + "07_mole.c4cf703b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/07_mole.png
// module id = f2Q/
// module chunks = 0